export default __webpack_public_path__ + "static/media/beta.c25de5ed.svg";